export const decimalSeparator = '.';
